import * as React from 'react'
import { Box, Container, Typography, Link } from '@mui/material'

/**
 * Footer component for displaying copyrights and app by.
 */
const Footer = () => {
  return (
    <Container
      maxWidth="xl"
      sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', gap: 1, pb: 2, displayPrint: 'none' }}
    >
      {/* Left Content */}
      <Box>
        <Typography variant="body2">
          {'Copyright © '}
          <Link color="inherit" href="https://freshmtl.ca/" target="_blank">
            Fresh MTL
          </Link>{' '}
          {new Date().getFullYear()}
          {'.'}
        </Typography>
      </Box>

      {/* Right Content */}
      <Box>
        <Typography variant="body2">
          <Link color="inherit" href="https://www.royaltri.com/" target="_blank">
            App by
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlSpace="preserve"
              id="Layer_1"
              x="0"
              y="0"
              viewBox="0 0 51.9 51.9"
              width={20}
              height={20}
              style={{
                position: 'relative',
                top: '0',
                verticalAlign: 'top',
                marginLeft: '6px',
              }}
            >
              <path d="m34.7 21.3-.5-.1.1-.5c.2-.7.3-1.4.3-2.2 0-4.8-3.9-8.7-8.7-8.7s-8.7 3.9-8.7 8.7c0 .7.1 1.5.3 2.2l.1.5-.5.1c-3.8 1-6.4 4.5-6.4 8.4 0 4.8 3.9 8.7 8.7 8.7 2.3 0 4.5-.9 6.1-2.5l.3-.3.3.3c1.6 1.6 3.8 2.5 6.1 2.5 4.8 0 8.7-3.9 8.7-8.7.2-3.9-2.5-7.3-6.2-8.4M19.5 33.4c-2 0-3.7-1.7-3.7-3.7s1.7-3.7 3.7-3.7 3.7 1.7 3.7 3.7c0 2.1-1.7 3.7-3.7 3.7m6.4-11.2c-2 0-3.7-1.7-3.7-3.7s1.7-3.7 3.7-3.7 3.7 1.7 3.7 3.7c0 2.1-1.6 3.7-3.7 3.7m6.5 11.2c-2 0-3.7-1.7-3.7-3.7s1.7-3.7 3.7-3.7 3.7 1.7 3.7 3.7c0 2.1-1.7 3.7-3.7 3.7"></path>
              <path d="M25.9 0C11.6 0 0 11.6 0 25.9s11.6 25.9 25.9 25.9 25.9-11.6 25.9-25.9C51.9 11.6 40.3 0 25.9 0m0 46.9c-11.6 0-21-9.4-21-21s9.4-21 21-21 21 9.4 21 21-9.4 21-21 21"></path>
            </svg>
          </Link>
        </Typography>
      </Box>
    </Container>
  )
}

export default Footer
